interface Props {
  children: React.ReactNode;
}

export default function TableRow({ children }: Props) {
  return <div className="flex gap-md p-md">{children}</div>;
}
